function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsSvgrepoComCropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon line-color",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Line Color",
    id: "stats",
    viewBox: "1.8560016 1.9040016 20.208 20.16",
    fill: "#",
    style: {
      maxHeight: 500
    },
    width: 20.208,
    height: 20.16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "rgb(0, 182, 235)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M12,17V11M8,17V15m8,2V7",
    id: "secondary"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "rgb(0, 138, 206)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    rx: 1,
    height: 18,
    width: 18,
    y: 3,
    x: 3,
    id: "primary"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsSvgrepoComCropped);
export default __webpack_public_path__ + "static/media/stats-svgrepo-com-cropped.76e7eb42443973e2501310f0bcd59ea8.svg";
export { ForwardRef as ReactComponent };